import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';

// RxJS
import { Observable } from 'rxjs';

// selectors
import * as fromRoot from './../../../store/selectors';

// services
import { LocalStorageService } from 'ngx-webstorage';
import { ClaimService } from './../../services';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'sucstu-claim',
  styleUrls: ['./claim.component.scss'],
  templateUrl: 'claim.component.html'
})
export class ClaimComponent implements OnInit {

  user$: Observable<any>;

  form = this.fb.group({
    email: '',
    claimCode: ''
  });

  userExist = false;
  isAuthenticated = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private store: Store<any>,
    private claimService: ClaimService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.user$ = this.store.pipe(select(fromRoot.getUserState));
    this.user$
      .subscribe(value => {
        this.isAuthenticated = value.isAuthenticated;
        this.form.get('email').setValue(value.data.email);
      });
  }

  claimSubscription() {
    this.claimService.checkClaimCode(this.form.value)
      .pipe(
        tap((response) => {
          this.localStorage.store('claimCode', this.form.value.claimCode);
          this.localStorage.store('customerEmail', this.form.value.email);
          if (response.recipient && response.address) {
            this.localStorage.store('customerAddress', JSON.stringify(response.address));
            this.localStorage.store('customerRecipient', JSON.stringify(response.recipient));
          }
        }),
        map((response) => this.checkUserExist(response))
      )
      .subscribe();
  }

  checkUserExist({ userExist }) {
    if (userExist && !this.isAuthenticated) {
      this.userExist = true;
      return;
    }

    this.router.navigate(['/claim-checkout']);
  }

  goToLogin() {
    this.router.navigate(['/login'], { queryParams: { redirect: 'claim-checkout' } });
  }
}
